// src/components/restaurant/OptOutWordManagement.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../../services/api';
function OptOutWordManagement() {
  const { restaurantId } = useParams();
  const [optOutWord, setOptOutWord] = useState('');
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('ownerToken');

  useEffect(() => {
    // const response = await axios.get(
    //   `/api/restaurants/${restaurantId}/subscribers`,
    //   {
    //     headers: {
    //       Authorization: `Bearer ${token}`,
    //     },
    //   }
    // );
    const fetchRestaurant = async () => {
      try {
        const { data } = await api.get(`/restaurants/${restaurantId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setOptOutWord(data.optOutWord);
        setLoading(false);
      } catch (error) {
        toast.error('Failed to load restaurant details');
        setLoading(false);
      }
    };

    fetchRestaurant();
  }, [restaurantId]);

  const handleUpdate = async () => {
    try {
      const { data } = await api.put(
        `/restaurants/${restaurantId}/opt-out-word`,
        {
          optOutWord,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setOptOutWord(data.optOutWord);
      toast.success('Opt Out Name updated successfully!');
    } catch (error) {
      toast.error('Failed to update Opt Out Name');
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className='max-w-md mx-auto mt-10'>
      <h2 className='text-2xl font-bold mb-4'>Change Your OPT OUT Message</h2>
      <h4 className='text-md font-bold mb-4 text-gray-700'>
        Subscribers can opt out of text message by replying: "OPT OUT (your
        keyword)"
      </h4>

      {/* <label
        htmlFor='content'
        className='block text-sm font-medium text-gray-700'
      >
        Message Content
      </label> */}

      {/* <input
        type='text'
        value={optOutWord}
        onChange={(e) => setOptOutWord(e.target.value)}
        placeholder='Enter new Opt Out Name'
      /> */}

      <div>
        <label
          htmlFor='content'
          className='block text-sm font-medium text-gray-700'
        >
          Your Keyword:
        </label>
        <textarea
          id='content'
          value={optOutWord}
          onChange={(e) => setOptOutWord(e.target.value)}
          required
          rows='4'
          className='mb-3 p-2 mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 border'
        ></textarea>
      </div>

      <button
        className='w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
        onClick={handleUpdate}
      >
        Update
      </button>
    </div>
  );
}

export default OptOutWordManagement;
